var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCognyModelLinesSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 354 266",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 195.75H130C122.45 195.75 116.813 195.749 112.477 195.166C108.148 194.584 105.152 193.426 102.863 191.137C100.574 188.848 99.4156 185.852 98.8336 181.523C98.2505 177.187 98.25 171.55 98.25 164V80C98.25 72.4505 98.2505 66.8135 98.8336 62.477C99.4156 58.1477 100.574 55.152 102.863 52.8631C105.152 50.5741 108.148 49.4156 112.477 48.8336C116.813 48.2505 122.45 48.25 130 48.25H224C231.55 48.25 237.187 48.2505 241.523 48.8336C245.852 49.4156 248.848 50.5741 251.137 52.8631C253.426 55.152 254.584 58.1477 255.166 62.477C255.749 66.8135 255.75 72.4505 255.75 80V164C255.75 171.55 255.749 177.187 255.166 181.523C254.584 185.852 253.426 188.848 251.137 191.137C248.848 193.426 245.852 194.584 241.523 195.166C237.187 195.749 231.55 195.75 224 195.75Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1015_9823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130 196H224C239.085 196 246.627 196 251.314 191.314C256 186.627 256 179.085 256 164V80C256 64.9151 256 57.3726 251.314 52.6863C246.627 48 239.085 48 224 48H130C114.915 48 107.373 48 102.686 52.6863C98 57.3726 98 64.9151 98 80V164C98 179.085 98 186.627 102.686 191.314C107.373 196 114.915 196 130 196Z",
    fill: "black",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      opacity: 0.5,
      strokeWidth: 2
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "line",
    style: {
      stroke: "#D3E6F8"
    },
    d: "M309,181h-34.9c-10.1,0-7.6-43-18-43H176"
  }), /*#__PURE__*/React.createElement("path", {
    className: "line",
    style: {
      stroke: "#F5D2ED"
    },
    d: "M309,66h-30.9c-15.6,0-8.1,72-21,72H176"
  }), /*#__PURE__*/React.createElement("path", {
    className: "line",
    style: {
      stroke: "#CCF2F2"
    },
    d: "M176,138H98c-13.5,0-5,27-18,27H40"
  }), /*#__PURE__*/React.createElement("path", {
    className: "line",
    style: {
      stroke: "#F5D2ED"
    },
    d: "M176,138H98c-9.5,0-9-21-18.5-21H40"
  }), /*#__PURE__*/React.createElement("path", {
    className: "line",
    style: {
      stroke: "#E3D6FF"
    },
    d: "M176,138H98c-12.5,0-5-67-18.1-67H40"
  }), /*#__PURE__*/React.createElement("path", {
    className: "line",
    style: {
      stroke: "#D3E6F8"
    },
    d: "M176,138H98c-15.5,0-5-112-18.5-112H40"
  }), /*#__PURE__*/React.createElement("path", {
    className: "line",
    style: {
      stroke: "#F5D2ED"
    },
    d: "M176,138H98.9c-14,0-7.4,71-18.9,71H40"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeDasharray: "4px 17px",
      strokeDashoffset: 0,
      strokeWidth: 4,
      strokeLinecap: "round",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "signal signal1",
    style: {
      stroke: "#D3E6F8"
    },
    d: "M309,181h-34.9c-10.1,0-7.6-43-18-43H176"
  }), /*#__PURE__*/React.createElement("path", {
    className: "signal signal2",
    style: {
      stroke: "#F5D2ED"
    },
    d: "M309,66h-30.9c-15.6,0-8.1,72-21,72H176"
  }), /*#__PURE__*/React.createElement("path", {
    className: "signal signal3",
    style: {
      stroke: "#CCF2F2"
    },
    d: "M176,138H98c-13.5,0-5,27-18,27H40"
  }), /*#__PURE__*/React.createElement("path", {
    className: "signal signal4",
    style: {
      stroke: "#F5D2ED"
    },
    d: "M176,138H98c-9.5,0-9-21-18.5-21H40"
  }), /*#__PURE__*/React.createElement("path", {
    className: "signal signal5",
    style: {
      stroke: "#E3D6FF"
    },
    d: "M176,138H98c-12.5,0-5-67-18.1-67H40"
  }), /*#__PURE__*/React.createElement("path", {
    className: "signal signal6",
    style: {
      stroke: "#D3E6F8"
    },
    d: "M176,138H98c-15.5,0-5-112-18.5-112H40"
  }), /*#__PURE__*/React.createElement("path", {
    className: "signal signal7",
    style: {
      stroke: "#F5D2ED"
    },
    d: "M176,138H98.9c-14,0-7.4,71-18.9,71H40"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1015_9823",
    x: 98,
    y: 48,
    width: 158,
    height: 148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1015_9823"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCognyModelLinesSmall);
export default __webpack_public_path__ + "static/media/cognyModelLinesSmall.2676760c90a700b2de711329712b2fd5.svg";
export { ForwardRef as ReactComponent };